import Layout from "@/shared/components/Layout";
import React from "react";
import { CookiesPolicyProps } from "./types";
import { MDXRemote } from "next-mdx-remote";
import Container from "@/shared/components/Container";
import styles from "./CookiesPolicy.module.scss";
import Head from "next/head";

const CookiesPolicy = ({ content, metadata }: CookiesPolicyProps) => {
  return (
    <Layout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
      </Head>
      <Container>
        <div className={styles.cookiesPolicy}>
          <MDXRemote {...content} />
        </div>
      </Container>
    </Layout>
  );
};

export default CookiesPolicy;
